import { Column, Row } from '@unistocks/components/layout/flex';
import { Paragraph } from '@unistocks/components/text/text';
import {
  externalTransactionDate,
  isExternalTransaction
} from '@unistocks/features/portfolios/transactions/transaction-consts';
import { TransactionDto, TransactionType } from '@unistocks/proxy/axios-client';
import { formatCurrency, formatDate, t } from '@unistocks/shared/localization/index.ts';
import React from 'react';

export type TransactionDetailsProps = {
  transaction: TransactionDto;
};

export const TransactionDetails: React.FC<TransactionDetailsProps> = ({ transaction }) => {
  const isExternal = isExternalTransaction(transaction);

  return (
    <Column mt={'$3'}>
      {isExternal ? (
        <>
          <Paragraph size={'$5'}>{t(`::Enum:TransactionType:${transaction.type}`)}</Paragraph>
          <Row gap={0}>
            <Paragraph size={'$5'}>{t('::Transaction:Date')}: </Paragraph>
            <Paragraph size={'$5'}>
              {formatDate(transaction.extraProperties[externalTransactionDate], {
                dateStyle: 'long'
              })}
            </Paragraph>
          </Row>
          <Row>
            <Paragraph size={'$5'}>{t('::Transaction:DateImported')}: </Paragraph>
            <Paragraph size={'$5'}>{formatDate(transaction.date, { dateStyle: 'long' })}</Paragraph>
          </Row>
        </>
      ) : (
        <Paragraph size={'$5'}>
          {`${t(`::Enum:TransactionType:${transaction.type}`)} ${formatDate(transaction.date, { dateStyle: 'long' })}`}
        </Paragraph>
      )}

      <Row>
        <Paragraph size={'$5'}>
          {t('::Transaction:Amount')}
          {': '}
        </Paragraph>
        <Paragraph
          size={'$5'}
          fontWeight={'$7'}
          color={transaction.type === TransactionType.Deposit ? '$unistocks' : '$danger'}
        >
          {formatCurrency(transaction.amount)}
        </Paragraph>
      </Row>

      {transaction.comment ? (
        <Paragraph mt={'$3'} size={'$5'}>
          {transaction.comment}
        </Paragraph>
      ) : null}
    </Column>
  );
};

TransactionDetails.displayName = 'TransactionDetails';
